import Vue from 'vue';

// axios
import axios from 'axios';
import region from '@/config/regions';

// The API host is resolved at runtime from the browser's hostname - see
// src/config/regions.js. The Authorization header is attached per request by
// the interceptor in src/@core/auth/jwt/jwtService.js.
const axiosIns = axios.create({
  baseURL: region.apiUrl,
});

Vue.prototype.$http = axiosIns;

export default axiosIns;
